<div *ngIf="layout" class="copo-product-container copo-product-flex-row">
	<!-- left column -->
	<div class="copo-product-flex-column-66">
		<ng-container
			*ngFor="let group of layout.groupsLeft"
			[ngTemplateOutlet]="fieldGroup"
			[ngTemplateOutletContext]="{ group: group }"
		></ng-container>
		<!-- bottom of left column -->
		<div *ngIf="layout.groupsLeftLeft.length > 0 || layout.groupsLeftRight.length > 0" class="copo-product-flex-row">
			<!-- left-left column -->
			<div *ngIf="layout.groupsLeftLeft.length > 0" class="copo-product-flex-column">
				<ng-container
					*ngFor="let group of layout.groupsLeftLeft"
					[ngTemplateOutlet]="fieldGroup"
					[ngTemplateOutletContext]="{ group: group }"
				></ng-container>
			</div>
			<!-- left-right column -->
			<div *ngIf="layout.groupsLeftRight.length > 0" class="copo-product-flex-column">
				<ng-container
					*ngFor="let group of layout.groupsLeftRight"
					[ngTemplateOutlet]="fieldGroup"
					[ngTemplateOutletContext]="{ group: group }"
				></ng-container>
			</div>
		</div>
	</div>
	<!-- right column -->
	<div class="copo-product-flex-column-33">
		<ng-container
			*ngFor="let group of layout.groupsRight"
			[ngTemplateOutlet]="fieldGroup"
			[ngTemplateOutletContext]="{ group: group }">
		</ng-container>
	</div>
</div>

<!-- group of characteristics-->
<ng-template #fieldGroup let-group="group">
	<div *ngIf="group.title !== 'product.title.group.weightDiameter' else weightAndDiameter" class="card-block">
		<!-- group title -->
		<div class="card-title" translate>{{group.title}}</div>

		<!-- group sections -->
		<div *ngFor="let section of group.sections">
			<mat-divider class="margin-divider"></mat-divider>

			<!-- section -->
			<div class="card-infos-block">

				<!-- section title -->
				<div *ngIf="section.title" class="card-sub-title" translate>{{section.title}}</div>

				<!-- section fields -->
				<div class="card-infos">
					<ng-container *ngFor="let field of section.fields" [ngTemplateOutlet]="anyField" [ngTemplateOutletContext]="{ field: field }"></ng-container>
				</div>
			</div>
		</div>
	</div>

	<ng-template #weightAndDiameter>
		<div class="card-block">
			<!-- group title -->
			<div class="card-title" translate>{{group.title}}</div>
			<!-- group sections -->
			<div>
				<mat-divider class="margin-divider"></mat-divider>
				<!-- section -->
				<div class="card-infos-block no-wrap">
					<!-- section title -->
					<div class="card-sub-title"></div>
					<div class="card-infos"><div class="card-info"><div class="card-info-label" translate>product.pc.label.unit</div></div></div>
					<div class="card-infos"><div class="card-info"><div class="card-info-label" translate>product.pc.label.min</div></div></div>
					<div class="card-infos"><div class="card-info"><div class="card-info-label" translate>product.pc.label.max</div></div></div>
					<div class="card-infos"><div class="card-info"><div class="card-info-label" translate></div></div></div>
				</div>
			</div>
			<div *ngFor="let section of group.sections">
				<mat-divider class="margin-divider"></mat-divider>

				<!-- section -->
				<div class="card-infos-block">

					<!-- section title -->
					<div *ngIf="section.title" class="card-sub-title" translate>{{section.title}}</div>
					<!-- unit -->
					<div class="card-infos">
						<ng-container [ngTemplateOutlet]="anyField" [ngTemplateOutletContext]="{ field: findFieldByRadical(section.fields, 'unit'), labelHidden: true }"></ng-container>
					</div>
					<!-- min -->
					<div class="card-infos">
						<ng-container [ngTemplateOutlet]="anyField" [ngTemplateOutletContext]="{ field: findFieldByRadical(section.fields, 'min'), labelHidden: true }"></ng-container>
					</div>
					<!-- max-->
					<div class="card-infos">
						<ng-container [ngTemplateOutlet]="anyField" [ngTemplateOutletContext]="{ field: findFieldByRadical(section.fields, 'max'), labelHidden: true }"></ng-container>
					</div>
					<!-- custom -->
					<div class="card-infos">
						<ng-container [ngTemplateOutlet]="anyField" [ngTemplateOutletContext]="{ field: findFieldByForbiddenRadical(section.fields, ['unit', 'min', 'max']), labelHidden: true }"></ng-container>
					</div>
				</div>
			</div>
		</div>
	</ng-template>

</ng-template>

<!-- field -->
<ng-template #anyField let-field="field" let-index="index" let-labelHidden="labelHidden">
	<ng-container *ngIf="field else blank">
		<ng-container [ngSwitch]="field.type">
			<ng-container *ngSwitchCase="NUMBER_CST" [ngTemplateOutlet]="numberCst" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchCase="NUMBER_VAR" [ngTemplateOutlet]="numberVar" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchCase="TEXT_CST" [ngTemplateOutlet]="textCst" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchCase="TEXT_VAR" [ngTemplateOutlet]="textVar" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchCase="TEXT_SELECTION" [ngTemplateOutlet]="textSelection" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchCase="LIST_CST" [ngTemplateOutlet]="listCst" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchCase="LIST_VAR" [ngTemplateOutlet]="listVar" [ngTemplateOutletContext]="{ field: field, index: index, labelHidden: labelHidden }"></ng-container>
			<ng-container *ngSwitchDefault>
				<span>unsupported field {{field.name}} of type {{field.type}}</span>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #blank>
		<div class="card-info"><div class="card-info-label"></div></div>
	</ng-template>
</ng-template>

<!-- constant number -->
<ng-template #numberCst let-field="field" let-index="index" let-labelHidden="labelHidden">
	<div class="card-info">
		<div *ngIf="!labelHidden" class="card-info-label">{{translate(field.name, index)}}</div>
		<div class="card-info-value copo-product-flex-column" [class.copo-product-text-align-right]="labelHidden">
			{{field.value() | copoNumber:'amount'}}
			<div *ngIf="field.isOriginalValueDifferent()" class="copo-product-hint-warning">
				<mat-icon svgIcon="alert" class="copo-product-hint-warning-icon"></mat-icon>
				<ng-container *ngIf="field.originalValue else noValue">{{'product.original.value' | translate}}: {{field.originalValue}}</ng-container>
				<ng-template #noValue>{{'product.no.original.value' | translate}}</ng-template>
			</div>
		</div>
	</div>
</ng-template>

<!-- variable number -->
<ng-template #numberVar let-field="field" let-index="index" let-labelHidden="labelHidden">
	<div class="card-info">
		<div *ngIf="!labelHidden" class="card-info-label">{{translate(field.name, index)}}</div>
		<div class="card-info-value copo-product-flex-column" [class.copo-product-text-align-right]="labelHidden">
			<div class="copo-product-flex-row-nowrap">
				<input
					#fieldInput
					matInput copoInputNumber
					[min]="field.minValue" [max]="field.maxValue" [step]="field.stepValue" [decimalCount]="field.decimalCount"
					[formControl]="field.control"
					class="copo-product-input-field"
				>
				<button *ngIf="field.value() !== undefined" type="button" matSuffix mat-icon-button (click)="field.control.reset(undefined); fieldInput.focus()" tabindex="-1">
					<mat-icon svgIcon="md:close"></mat-icon>
				</button>

				<mat-icon svgIcon="md:edit" class="copo-offer-center-vertical"></mat-icon>
			</div>

			<div *ngIf="field.isOriginalValueDifferent()" class="copo-product-hint-warning">
				<mat-icon svgIcon="alert" class="copo-product-hint-warning-icon"></mat-icon>
				<ng-container *ngIf="field.originalValue else noValue">{{'product.original.value' | translate}}: {{field.originalValue}}</ng-container>
				<ng-template #noValue>{{'product.no.original.value' | translate}}</ng-template>
			</div>
		</div>
	</div>
</ng-template>

<!-- constant text -->
<ng-template #textCst let-field="field" let-index="index" let-labelHidden="labelHidden">
	<div class="card-info">
		<div *ngIf="!labelHidden" class="card-info-label">{{translate(field.name, index)}}</div>
		<div class="card-info-value copo-product-flex-column" [class.copo-product-text-align-right]="labelHidden">
			{{field.value()}}
			<div *ngIf="field.isOriginalValueDifferent()" class="copo-product-hint-warning">
				<mat-icon svgIcon="alert" class="copo-product-hint-warning-icon"></mat-icon>
				<ng-container *ngIf="field.originalValue else noValue">{{'product.original.value' | translate}}: {{field.originalValue}}</ng-container>
				<ng-template #noValue>{{'product.no.original.value' | translate}}</ng-template>
			</div>
		</div>
	</div>
</ng-template>

<!-- variable text -->
<ng-template #textVar let-field="field" let-index="index" let-labelHidden="labelHidden">
	<div class="card-info">
		<div *ngIf="!labelHidden" class="card-info-label">{{translate(field.name, index)}}</div>
		<div class="card-info-value copo-product-flex-column" [class.copo-product-text-align-right]="labelHidden">
			<div class="copo-product-flex-row-nowrap">
				<input
					#fieldInput
					copoInputText
					matInput
					type="text"
					[maxLength]="field.maxLength"
					[formControl]="field.control"
					class="copo-product-input-field"
				>
				<button *ngIf="field.value !== undefined" type="button" matSuffix mat-icon-button (click)="field.control.reset(undefined); fieldInput.focus()" tabindex="-1">
					<mat-icon svgIcon="md:close"></mat-icon>
				</button>

				<mat-icon svgIcon="md:edit" class="copo-offer-center-vertical"></mat-icon>
			</div>

			<div *ngIf="field.isOriginalValueDifferent()" class="copo-product-hint-warning">
				<mat-icon svgIcon="alert" class="copo-product-hint-warning-icon"></mat-icon>
				<ng-container *ngIf="field.originalValue else noValue">{{'product.original.value' | translate}}: {{field.originalValue}}</ng-container>
				<ng-template #noValue>{{'product.no.original.value' | translate}}</ng-template>
			</div>
		</div>
	</div>
</ng-template>

<!-- variable selection -->
<ng-template #textSelection let-field="field" let-index="index" let-labelHidden="labelHidden">
	<div class="card-info">
		<div *ngIf="!labelHidden" class="card-info-label">{{translate(field.name, index)}}</div>
		<div class="card-info-value copo-product-flex-column" [class.copo-product-text-align-right]="labelHidden">
			<div class="copo-product-flex-row-nowrap">
				<input
					#fieldInput
					copoInputText
					matInput
					type="text"
					spellcheck="false"
					autocomplete="off"
					[matAutocomplete]="autoGroup"
					[formControl]="field.control"
					[matTooltip]="field.control.value"
					class="copo-product-input-field"
				>
				<button *ngIf="field.value() !== undefined" type="button" matSuffix mat-icon-button (click)="field.control.reset(undefined); fieldInput.focus()" tabindex="-1">
					<mat-icon svgIcon="md:close"></mat-icon>
				</button>
				<mat-autocomplete #autoGroup="matAutocomplete">
					<mat-optgroup
						*ngFor="let groupValues of field.filteredValues | async"
						[label]="groupValues.name | translate"
					>
						<mat-option
							*ngFor="let codeValue of groupValues.values"
							[matTooltip]="codeValue.value"
							[value]="codeValue.value"
							(onSelectionChange)="fieldInput.blur()"
						>
							{{codeValue.value}}
						</mat-option>
					</mat-optgroup>
				</mat-autocomplete>
				<mat-icon svgIcon="md:edit" class="copo-offer-center-vertical"></mat-icon>
			</div>

			<div *ngIf="field.isOriginalValueDifferent()" class="copo-product-hint-warning">
				<mat-icon svgIcon="alert" class="copo-product-hint-warning-icon"></mat-icon>
				<ng-container *ngIf="field.originalValue else noValue">{{'product.original.value' | translate}}: {{field.originalValue}}</ng-container>
				<ng-template #noValue>{{'product.no.original.value' | translate}}</ng-template>
			</div>
		</div>
	</div>
</ng-template>

<!-- constant list -->
<ng-template #listCst let-field="field">
	<div *ngFor="let entry of field.entries; let indexEntry=index" class="card-infos-block">
		<div class="card-sub-title copo-product-flex-row">
			{{translate(field.name)}}&nbsp;{{indexEntry + 1}}
		</div>
		<div class="card-infos">
			<ng-container
				*ngFor="let entryFieldName of field.getEntryFieldNames()"
				[ngTemplateOutlet]="anyField"
				[ngTemplateOutletContext]="{ field: entry.getField(entryFieldName) }"
			></ng-container>
		</div>
	</div>
</ng-template>

<!-- variable list -->
<ng-template #listVar let-field="field">
	<div *ngFor="let entry of field.entries; let indexEntry=index" class="card-infos-block">
		<div class="card-sub-title copo-product-flex-row-nowrap">
			{{translate(field.name)}}&nbsp;{{indexEntry + 1}}
			<button
				type="button"
				matSuffix mat-icon-button
				(click)="field.removeEntryAt(indexEntry)"
				tabindex="-1"
				class="card-info"
			>
				<mat-icon svgIcon="md:delete"></mat-icon>
			</button>
		</div>
		<div class="card-infos">
			<ng-container
				*ngFor="let entryFieldName of field.getEntryFieldNames()"
				[ngTemplateOutlet]="anyField"
				[ngTemplateOutletContext]="{ field: entry.getField(entryFieldName) }"
			></ng-container>
		</div>
	</div>

	<button *ngIf="field.isNewEntryAllowed()" type="button" matSuffix mat-icon-button (click)="field.addNewEntry()" tabindex="-1">
		<mat-icon svgIcon="md:add"></mat-icon>
		<span>{{ translate(field.name) }}</span>
	</button>
</ng-template>
